export function Spinner({ label }: { label?: string }) {
  return (
    <div className="spinner-wrap">
      <div className="spinner" />
      {label ? <p className="muted">{label}</p> : null}
    </div>
  );
}
